
const initialState = {
    accounts: []
};


function AccountReducer(state = initialState, action) {

    if (action.type === "ACCOUNT_LIST") {
        var accountDetails = {
            ...state,
            accounts: action.payload
        };
        return accountDetails;
    }
    return state;
}

export default AccountReducer;
